import { threeStore } from '@/modules/three/store/threeStore';
import type { JawsScanResponse } from '@/schema/jawsScan';
import { BaseThreeScene } from '@modules/three/common/BaseThreeScene';
import SegmentationService from '@segmentation/services/segmentationService';
import { AmbientLight } from 'three';

export class SegmentationScene extends BaseThreeScene {
  constructor(
    container: HTMLElement,
    private jawsScan: JawsScanResponse,
  ) {
    super(container);
    this.root.camera.position.set(0, 0, 150);
  }

  /**
   * Load the two jaw meshes, wire up segmentation, and start the render loop
   */
  public async init() {
    this.root.renderer.setClearColor('#0b1120');
    threeStore.setState({ isLoading: true });
    const ambientLight = new AmbientLight(0xffffff, 1);
    this.root.scene.add(ambientLight);
    const segmentation = new SegmentationService();
    await segmentation.createJaws(this.jawsScan);
    this.startRendering();
    const { gizmo, scene } = this.root;
    // Detach and remove gizmo
    if (gizmo) {
      gizmo.detach();
      if (typeof gizmo.getHelper === 'function') {
        const helper = gizmo.getHelper();
        if (helper) scene.remove(helper);
      }
    }
    threeStore.setState({ isLoading: false });
  }
}
